const initialState = {
   checkForDelete: true,
   calendarDate: new Date(),
   calendarViewType: "month",
}

export default function (state = initialState, action) {
   switch (action.type) {
      case "DO_NOT_CHECK_FOR_DELETE_SONG_IN_RECOMMENDATIONS": {
         return {
            ...state,
            checkForDelete: false,
         }
      }
      case "KEEP_CALENDAR_DATE": {
         return {
            ...state,
            calendarDate: action.payload,
         }
      }
      case "KEEP_CALENDAR_VIEW": {
         return {
            ...state,
            calendarViewType: action.payload,
         }
      }
      default:
         return state;
   }

}



// WEBPACK FOOTER //
// ./src/reducers/viewReducer.js